/* eslint-disable max-len */
interface IMockdata {
  courseCode: string;
  courseName: string;
  cls: string;
  imgSrc: string;
  date: string;
  session: number;
  room: string;
  time: string;
}

export const mockdata: IMockdata[] = [
  {
    courseCode: 'COE 354',
    courseName: 'Basic Electronic',
    cls: 'AE 1',
    imgSrc: 'https://templatelab.com/wp-content/uploads/2015/11/Attendance-Sheet-28.jpg',
    date: '12/12/43',
    session: 1,
    room: 'Room 1',
    time: new Date().getTime().toString(),
  },
  {
    courseCode: 'COE 354',
    courseName: 'Basic Electronic',
    cls: 'AE 1',
    imgSrc: 'https://templatelab.com/wp-content/uploads/2015/11/Attendance-Sheet-28.jpg',
    date: '12/12/43',
    session: 1,
    room: 'Room 1',
    time: new Date().getTime().toString(),
  },
  {
    courseCode: 'COE 354',
    courseName: 'Basic Electronic',
    cls: 'AE 1',
    imgSrc: `https://i.pinimg.com/736x/f4/8d/c7/f48dc7613cd184aaeee8a655ca5e4b9b.jpg`,
    date: '12/12/43',
    session: 1,
    room: 'Room 1',
    time: new Date().getTime().toString(),
  },
  {
    courseCode: 'COE 354',
    courseName: 'Basic Electronic',
    cls: 'AE 1',
    imgSrc: 'https://templatelab.com/wp-content/uploads/2015/11/Attendance-Sheet-28.jpg',
    date: '12/12/43',
    session: 1,
    room: 'Room 1',
    time: new Date().getTime().toString(),
  },
];
